import type { SVGProps } from "react";

/**
 * Solar "Bell Bing" (linear), as drawn in the Nasam Figma file -- the
 * installed `@solar-icons/react` doesn't ship it. Paints with currentColor
 * like the library icons.
 */
export function BellBingLinearIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M8.5 4C8.5 3.72386 8.27614 3.5 8 3.5C7.72386 3.5 7.5 3.72386 7.5 4V6.66667C7.5 6.94281 7.72386 7.16667 8 7.16667C8.27614 7.16667 8.5 6.94281 8.5 6.66667V4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.83338 6C2.83338 3.14653 5.14657 0.833333 8.00004 0.833333C10.8535 0.833333 13.1667 3.14653 13.1667 6V6.4694C13.1667 6.93402 13.3042 7.38823 13.562 7.77482L14.3277 8.92342C15.2164 10.2565 14.538 12.0685 12.9922 12.4901C12.4885 12.6275 11.9804 12.7437 11.4695 12.8387L11.4682 12.8421C10.9555 14.2101 9.58533 15.1667 8 15.1667C6.41467 15.1667 5.04446 14.2101 4.5318 12.8421L4.53054 12.8387C4.0196 12.7437 3.5116 12.6275 3.00786 12.4901C1.46213 12.0685 0.783662 10.2565 1.67239 8.92342L2.43813 7.77482C2.69585 7.38823 2.83338 6.93402 2.83338 6.4694V6ZM5.74901 13.0246C7.24431 13.2033 8.75568 13.2033 10.251 13.0246C9.77701 13.7057 8.95264 14.1667 8 14.1667C7.04736 14.1667 6.22298 13.7057 5.74901 13.0246ZM8.00004 1.83333C5.69886 1.83333 3.83338 3.69881 3.83338 6V6.4694C3.83338 7.13144 3.63741 7.77867 3.27018 8.32952L2.50444 9.47812C1.99433 10.2433 2.38376 11.2834 3.27098 11.5253C6.36715 12.3697 9.63294 12.3697 12.7291 11.5253C13.6163 11.2834 14.0058 10.2433 13.4956 9.47812L12.7299 8.32952C12.3627 7.77867 12.1667 7.13144 12.1667 6.4694V6C12.1667 3.69881 10.3012 1.83333 8.00004 1.83333Z"
        fill="currentColor"
      />
    </svg>
  );
}
